import { useEffect, useState } from "react";
import api, { usd } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Users } from "lucide-react";
import { fmtDate } from "@/components/DatePicker";
import { formatPhone } from "@/lib/phone";

export function MyTeamCard() {
  const [t, setT] = useState(null);
  useEffect(() => { api.get("/hr/my-team").then((r) => setT(r.data)).catch(() => {}); }, []);
  if (!t || t.reports.length === 0) return null;
  const p = t.permissions;
  return (
    <Card className="p-5 space-y-3" data-testid="my-team-card">
      <div><h2 className="font-display font-semibold flex items-center gap-2"><Users className="w-4 h-4 text-primary" /> My team</h2><p className="text-xs text-muted-foreground">{t.reports.length} direct report{t.reports.length === 1 ? "" : "s"}</p></div>
      <div className="divide-y divide-border text-sm">{t.reports.map((r) => (
        <div key={r.id} className="py-2 grid sm:grid-cols-[1fr_1fr_1fr] gap-2" data-testid={`team-member-${r.id}`}>
          <div><div className="font-medium">{r.name}</div><div className="text-xs text-muted-foreground">{r.job_title}{r.department ? ` · ${r.department}` : ""}{r.hire_date ? ` · since ${fmtDate(r.hire_date)}` : ""}</div></div>
          <div className="text-xs text-muted-foreground">{p.contacts ? <>{r.email && <div>{r.email}</div>}{r.phone && <div>{formatPhone(r.phone)}</div>}</> : <span className="italic">Contact info hidden</span>}{p.pay && <div className="font-mono-num text-foreground">{r.pay_type === "hourly" ? `${usd(r.hourly_rate)}/hr` : `${usd(r.annual_salary)}/yr`}</div>}</div>
          <div className="text-xs text-muted-foreground">{p.emergency && r.emergency_contacts?.length ? r.emergency_contacts.map((c, i) => <div key={i}>Emergency: {c.name}{c.relationship ? ` (${c.relationship})` : ""} {formatPhone(c.phone)}</div>) : null}<div>PTO {r.pto_balance ?? 0} days</div></div>
        </div>))}</div>
    </Card>
  );
}
